module.exports = __webpack_public_path__ + "img/sun_white_mod.56a7ff74.svg";